import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import ScrollToTop from "react-router-scroll-top";

// register busines steps
import RegisterBusinessStep1 from "../pages/RegisterBusinessStep1";
import RegisterBusinessStep2 from "../pages/RegisterBusinessStep2";
import RegisterBusinessStep3a from "../pages/RegisterBusinessStep3a";
import RegisterBusinessStep3 from "../pages/RegisterBusinessStep3";
import RegisterBusinessStep4 from "../pages/RegisterBusinessStep4";
import RegisterBusinessStep5 from "../pages/RegisterBusinessStep5";
import RegisterBusinessStep6a from "../pages/RegisterBusinessStep6a";
import RegisterBusinessStep6 from "../pages/RegisterBusinessStep6";
import ChooseOwner from "../pages/choose_owner/ChooseOwner";
// Dashbord Page components
import profilefirst from "../pages/Dashbord/profile-first/profilefirst";
import Changepass from "../pages/Dashbord/change-pass/Changepass";
import Favorites from "../pages/Dashbord/favorites/Favorites";
import Options from "../pages/Dashbord/options/Options";
import Messages from "../pages/Dashbord/messages/Messages";
import Exit from "../pages/Dashbord/Exit/Exit";
//business dashboard Pages
import BusinessDashboard from "../pages/business/dashboard/BusinessDashboard";
import BusinessInformation from "../pages/business/Information/BusinessInformation";
import BusinessOption from "../pages/business/Option/BusinessOption";
import BusinessMessage from "../pages/business/Message/BusinessMessage";
import BusinessImage from "../pages/business/image/business_image";
import BusinessReport from "../pages/business/Report/BusinessReport";
import BusinessTablighat from "../pages/business/tablighat/business_tablighat";
import BusinessSetting from "../pages/business/setting/BusinessSetting";
import BusinessExit from "../pages/business/Exit/BusinessExit";
// login pages
import Login from "../components/login/Login";
import Signup from "../components/signup/Signup";
import ForgetPass from "../components/login/ForgetPass";
import ChangePass from "../components/login/ChangePass";
import CheckComplete from "../pages/checkComplete/CheckComplete";
//email registery page
import EmailRegisteryPage from "../pages/Registery/EmailRegisteryPage";
import WelcomePage from "../pages/Registery/WelcomePage";
// landing page
import Landing from "../pages/landingPage/Landing";
//
import NotFound from "../pages/NotFound/NotFound";

// config
import configData from "../config/config.json";

const Layout = () => {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Switch>
          {/* Registery */}
          <Route path="/confirm-email" component={WelcomePage} />
          <Route path="/register-email" component={EmailRegisteryPage} />

          {/* choose owner */}
          {/* <Route path="/choose-owner" component={ChooseOwner} /> */}
          {/* login */}
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          <Route path="/forget-password" component={ForgetPass} />
          <Route path="/change-password" component={ChangePass} />
          <Route path="/check-complete" component={CheckComplete} />

          {/* sabt kasb o kar */}
          <Route
            path="/register-business-step1"
            component={RegisterBusinessStep1}
          />
          <Route
            path="/register-business-step2"
            component={RegisterBusinessStep2}
          />
          <Route
            path="/register-business-step3"
            component={RegisterBusinessStep3a}
          />
          <Route
            path="/register-business-step4"
            component={RegisterBusinessStep3}
          />
          <Route
            path="/register-business-step5"
            component={RegisterBusinessStep4}
          />
          <Route
            path="/register-business-step6"
            component={RegisterBusinessStep5}
          />
          <Route
            path="/register-business-step7"
            component={RegisterBusinessStep6a}
          />
          <Route
            path="/register-business-step8"
            component={RegisterBusinessStep6}
          />

          {/* business dashboard */}
          <Route path={"/business-dashboard"} component={BusinessDashboard} />
          <Route
            path={"/business-information"}
            component={BusinessInformation}
          />
          <Route path={"/business-reviews"} component={BusinessOption} />
          <Route path={"/business-message"} component={BusinessMessage} />
          <Route path={"/business-images"} component={BusinessImage} />
          <Route path={"/business-report"} component={BusinessReport} />
          <Route path={"/business-ads"} component={BusinessTablighat} />
          <Route path={"/business-setting"} component={BusinessSetting} />
          <Route path={"/business-exit"} component={BusinessExit} />
          {/* <Route exact path="/en" /> */}
          {/* <Route
            path=""
            component={() => {
              window.location.href = `${configData.SITE_URL}/404`;
              return null;
            }}
          /> */}
          {/* landing page */}
          <Route exact path="/" component={Landing} />

          <Route path="/404" component={NotFound} />
          <Redirect to="/404" />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default Layout;
